var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flipster",class:['flipster', ("flipsterUpdate" + _vm.propertyId), 'd-flex', 'justify-content-center', 'overflow-hidden']},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }